export default "__VITE_ASSET__5bd550f4__"